const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;
    this.requestId = 0;
    this.cardStyle9MobileOptionsCache = new Map();

    // Event delegation for quick view button
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        if (this.isLoading) return;
        this.target = target;
        this.toggleLoading(true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.loadProductQuickView(productHandle);
      },
    });

    // Subscribe to cart update events
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.modal.close();
    });
    window.MinimogEvents.subscribe('ON_MODAL_CLOSED', (modal) => {
      this.close();
    });
  }

  // Load product quick view HTML
  loadProductQuickView(productHandle) {
    const isCardStyle9MobileOptions = this.isCardStyle9MobileOptions();

    if (this.isOpen) {
      this.modal && this.modal.close(); // Close any existing modal before loading a new one
    }
    const requestId = ++this.requestId;
    this.isLoading = true;
    const cachedContent = isCardStyle9MobileOptions
      ? this.cardStyle9MobileOptionsCache.get(productHandle)?.cloneNode(true)
      : null;
    const quickViewRequest = cachedContent
      ? Promise.resolve(cachedContent)
      : fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` });

    quickViewRequest
      .then((html) => {
        if (requestId !== this.requestId) return null;
        if (isCardStyle9MobileOptions && !cachedContent) {
          this.cardStyle9MobileOptionsCache.set(productHandle, html.cloneNode(true));
          html = html.cloneNode(true);
        }

        this.modalContent = isCardStyle9MobileOptions
          ? this.buildCardStyle9MobileOptionsContent(html)
          : html.querySelector("#MainProduct-quick-view__content");
        if (!this.modalContent) throw new Error("Quick view content not found");

        const productInfo = this.modalContent.querySelector("product-info");
        if (!productInfo) throw new Error("Quick view product info not found");

        const colorScheme = productInfo.dataset.colorScheme;
        this.modalContent.classList.toggle("m-product-card-9-mobile-options-popup", isCardStyle9MobileOptions);
        this.setCardStyle9MobileOptions(isCardStyle9MobileOptions);
        this.modal.appendChild(this.modalContent);
        this.modal.setWidth(isCardStyle9MobileOptions ? "640px" : "960px");
        this.setCardStyle9MobileOptions(isCardStyle9MobileOptions);
        if (isCardStyle9MobileOptions) this.bindCardStyle9MobileOptionsContent();

        const sectionWrapper = this.modal.modal.querySelector('#MainProduct-quick-view__content');
        if (!sectionWrapper) throw new Error("Quick view section wrapper not found");

        sectionWrapper.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.modal.open();
        this.modal.setSizes(`m-gradient ${colorScheme}`);

        this.toggleLoading(false);
        this.isOpen = true;
        this.isLoading = false; // Reset loading state
        return true;
      })
      .then((loaded) => {
        if (!loaded || requestId !== this.requestId) return;

        document.dispatchEvent(
          new CustomEvent('tcustomizer-custom-show-quick-view', {
            detail: { productHandle: this.target.dataset.productHandle }
          })
        );

        document.dispatchEvent(
          new CustomEvent("quick-view:loaded", {
            detail: { productUrl: this.target.dataset.productHandle }
          })
        );
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);
        this.toggleLoading(false);
        this.isLoading = false;
        this.setCardStyle9MobileOptions(false);
      });
  }

  // Close the quick view modal
  close() {
    this.requestId += 1;
    this.toggleLoading(false);
    this.setCardStyle9MobileOptions(false);
    this.isOpen = false;
    this.isLoading = false;
  }

  isCardStyle9MobileOptions() {
    return this.target?.dataset.productCard9MobileOptionsPopup === "true";
  }

  buildCardStyle9MobileOptionsContent(html) {
    const sourceContent = html.querySelector("#MainProduct-quick-view__content");
    const productInfo = sourceContent?.querySelector("product-info");
    const variantPicker = productInfo?.querySelector(".main-product__block-variant_picker variant-picker");
    const productForm = productInfo?.querySelector(".main-product__block-buy_buttons product-form");
    if (!sourceContent || !productInfo || !variantPicker || !productForm) return sourceContent;

    const titleId = `ProductCard9MobileOptionsTitle-${productInfo.dataset.sectionId || "quick-view"}`;
    const content = document.createElement("div");
    content.id = sourceContent.id;

    Array.from(sourceContent.children).forEach((element) => {
      if (element === productInfo) return;
      if (["LINK", "STYLE", "SCRIPT"].includes(element.tagName)) content.appendChild(element);
    });

    productInfo.className = "m-product-card-9-mobile-options-product m:block m:w-full";
    productInfo.innerHTML = "";

    const header = document.createElement("div");
    header.className = "m-sticky-addtocart__variant-sheet-header";
    header.innerHTML = `
      <strong id="${titleId}">ESCOLHA AS OPÇÕES</strong>
      <button
        type="button"
        class="m-sticky-addtocart__variant-sheet-close"
        data-sticky-atc-sheet-close
        aria-label="${window.MinimogStrings?.close || "Fechar"}"
      >&times;</button>
    `;

    const pickerWrapper = document.createElement("div");
    pickerWrapper.className = "m-sticky-addtocart__variant-sheet-picker";
    pickerWrapper.appendChild(variantPicker);

    productForm.classList.remove("m:w-full");
    productForm.classList.add("m-sticky-addtocart__variant-sheet-form");
    productForm.setAttribute("data-sticky-atc-sheet-form", "");
    productForm.querySelector("form")?.classList.add("sticky-atc-sheet-form");
    productForm.querySelector('input[name="id"]')?.setAttribute("data-sticky-atc-sheet-variant-input", "");

    productInfo.appendChild(header);
    productInfo.appendChild(pickerWrapper);
    productInfo.appendChild(productForm);
    content.appendChild(productInfo);

    return content;
  }

  bindCardStyle9MobileOptionsContent() {
    const modalContent = this.modal?.modal?.querySelector(".m-modal--content");
    const title = this.modalContent?.querySelector(".m-sticky-addtocart__variant-sheet-header strong");

    modalContent?.setAttribute("role", "dialog");
    modalContent?.setAttribute("aria-modal", "true");
    modalContent?.setAttribute("tabindex", "-1");
    if (title?.id) modalContent?.setAttribute("aria-labelledby", title.id);

    this.modalContent?.querySelectorAll("[data-sticky-atc-sheet-close]").forEach((button) => {
      button.addEventListener("click", () => this.modal?.close());
    });
  }

  setCardStyle9MobileOptions(isEnabled) {
    const modalContent = this.modal?.modal?.querySelector(".m-modal--content");

    this.modal?.modal?.classList.toggle("m-product-card-9-mobile-options-modal", isEnabled);
    this.modal?.modal?.classList.toggle("m-sticky-addtocart__variant-sheet", isEnabled);
    modalContent?.classList.toggle("m-sticky-addtocart__variant-sheet-content", isEnabled);
    this.modalContent?.classList.toggle("m-product-card-9-mobile-options-popup", isEnabled);
    if (!isEnabled) modalContent?.removeAttribute("aria-labelledby");
    if (!isEnabled && this.target?.dataset.productCard9MobileOptionsPopup === "true") {
      delete this.target.dataset.productCard9MobileOptionsPopup;
    }
  }

  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (!this.target) return;

    if (isLoading) {
      this.target.classList.add("m-spinner-loading");
    } else {
      this.target.classList.remove("m-spinner-loading");
    }
  }
}

// Initialize the QuickView instance
MinimogTheme.ProductQuickView = new QuickView();
